var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6998 6.8C8.29982 6.8 3.89982 11.3 4.09982 16.7C4.29982 22.1 8.39982 25.9 13.4998 26.1C18.8998 26.3 23.3998 21.9 23.3998 16.5H13.7998V6.8H13.6998Z",
    fill: "#00ADEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 13.5H26.2001C26.2001 8.2 21.9001 3.9 16.6001 3.9V13.5Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieActive);
export default __webpack_public_path__ + "static/media/pie-active.c7780a7ab6f835b19521883c7adf30c9.svg";
export { ForwardRef as ReactComponent };